import { render, staticRenderFns } from "./openPriceSim.vue?vue&type=template&id=079fe4f4&scoped=true&"
import script from "./openPriceSim.vue?vue&type=script&lang=js&"
export * from "./openPriceSim.vue?vue&type=script&lang=js&"
import style0 from "./openPriceSim.vue?vue&type=style&index=0&id=079fe4f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fe4f4",
  null
  
)

export default component.exports